module.exports = __webpack_public_path__ + "img/US-UK_Add_to_Apple_Wallet_RGB_101421.0b5b9bd4.svg";